<template>
  <div class="app_menu_container">
    <PageTitle :title="title" backPath="Home" />
    <div class="app_menu_main">
      <PageSearchDataList
        ref="PageSearchDataListRef"
        @toDetail="toDetail"
        :searchData="searchData"
        @loadNextPageData="loadNextPageData"
        :cardOption="cardOption"
      />
    </div>
  </div>
</template>
<script>
import PageTitle from '@/components/app/PageHeader.vue'
import PageSearchDataList from '@/components/app/PageSearchDataList.vue'

export default {
  components: {
    PageTitle,
    PageSearchDataList
  },
  data() {
    return {
      title: '邮寄',
      searchData: [],
      // 分页设置
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 10, // 每页10条
        align: 'right',
        layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
        perfect: true
      },
      // 卡片配置
      cardOption: {
        path: 'MailRecords',
        title: '邮寄',
        mainPersonKey: 'sender',
        mainDateKey: 'ship_date',
        col: [
          {
            label: '寄件内容',
            key: 'contribution_details',
            type: 'string'
          },
          {
            label: '是否加急',
            key: 'is_expedited',
            type: 'string'
          },
          {
            label: '收件单位',
            key: 'receiving_company',
            type: 'string'
          },
          {
            label: '收件人',
            key: 'recipient',
            type: 'string'
          }
        ]
      },
      menuArgs: ''
    }
  },
  mounted() {
    if (this.$route.query?.type && this.$route.query.type === 'todo') {
      this.menuArgs = 'phone'
    } else {
      this.menuArgs = ''
    }

    this.list()
  },
  methods: {
    // 获取数据
    async list() {
      const { data: res } = await this.$http.post('/Finance/Mail_records/list', {
        pageIndex: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize,
        seeType: 4,
        searchObjects: [],
        menuArgs: this.menuArgs
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.searchData = [...this.searchData, ...res.data.rows]
      this.tablePage.total = res.data.totals
      if (this.searchData.length === this.tablePage.total) {
        this.$refs.PageSearchDataListRef.isLoadAll = true
      }
      this.$refs.PageSearchDataListRef.isLoading = false
    },
    toDetail(item) {
      this.$router.push({
        path: '/AppMailRecordsDetail',
        query: {
          id: item.id,
          menuArgs: this.menuArgs
        }
      })
    },
    // 加载更多
    loadNextPageData() {
      this.tablePage.currentPage++
      this.list()
    }
  }
}
</script>
<style lang="less" scoped>
@headerHeight: 50px;

.app_menu_container {
  width: 100vw;
  height: 100vh;

  .app_menu_main {
    height: calc(100% - @headerHeight);
    width: 100%;
    background-color: #fafafa;
  }
}
</style>
